import { IComponentOptions } from "angular";
import { BulkLogController } from "./controller";

export const vsComponentName = "bulkLog";

export const bulkLogComponentOptions: IComponentOptions =
  {
    controller: BulkLogController,
    template: require("!html-loader!./index.html").default,
    controllerAs: "stateController",
    bindings: {
      bulkLogs: "<"
    },
  };
